import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { DataGrid } from '@mui/x-data-grid';

function WalmartPalletAllocationTable(props) {

    const {
        palletAssignments = {},
        setPalletAssignments
    } = props;

    const columns = [
        {
            field: 'internal_po_number',
            headerName: 'PO Number',
            flex: 1,
            minWidth: 150,
            editable: false
        },
        {
            field: 'internal_sku',
            headerName: 'SKU',
            flex: 1,
            minWidth: 150,
            editable: false
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            flex: 1,
            minWidth: 100,
            editable: false
        },
        {
            field: 'box_sscc',
            headerName: 'Box SSCC',
            flex: 1.5,
            minWidth: 220,
            editable: false
        },
        {
            field: 'pallet_number',
            headerName: 'Pallet Number',
            flex: 1,
            minWidth: 150,
            sortable: false,
            renderCell: (params) => {

                const rowKey = params.row.order_id;

                return (
                    <TextField
                        type="number" 
                        inputProps={{inputMode: "numeric", pattern: "[0-9]*", onWheel: event => event.currentTarget.blur()}}
                        size="small"
                        value={palletAssignments[rowKey] ?? ""}
                        onChange={(event) => {
                            const value = event.target.value;

                            setPalletAssignments((current) => ({
                                ...current,
                                [rowKey]: value
                            }));
                        }}
                        sx={{
                            '& input[type=number]': {
                                MozAppearance: 'textfield'
                            },
                            '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                WebkitAppearance: 'none',
                                margin: 0
                            }
                        }}
                    />
                );
            }
        }
    ];

    return (
        <Box
            className={props.isMobile ? "mobile-box" : "desktop-box"}
            sx={{ mt: '20px' }}
        >
            <DataGrid
                className={ props.isMobile ? "mobile-table" : "desktop-table"}
                autoHeight
                rows={props.orders}
                columns={columns}
                getRowId={(row) => row.order_id}
                rowsPerPageOptions={[25, 50, 100]}
                checkboxSelection={false}
            />
        </Box>
    );
}

export default WalmartPalletAllocationTable;